import type { AppUser } from '@/lib/auth';
import { requireAdminOrManager } from '@/lib/auth/guards';
import { isServiceError, normalizeError } from '@/lib/services/errors';
import { getUnitLeaseContact } from '@/lib/supabase/unitLeaseContacts';
import type { UnitLeaseContact } from '@/lib/types/property';

export interface GetUnitLeaseContactArgs {
  user: AppUser | null;
  unitId: string;
}

export async function getUnitLeaseContactForUser({
  user,
  unitId,
}: GetUnitLeaseContactArgs): Promise<UnitLeaseContact | null> {
  const actor = requireAdminOrManager(user);
  void actor;

  try {
    return await getUnitLeaseContact(unitId);
  } catch (error) {
    if (isServiceError(error)) {
      throw error;
    }

    throw normalizeError(error);
  }
}
